import { useEffect, useMemo } from 'react';
import { debounce } from 'lodash-es';

import type { RefObject } from 'react';

export const useHeaderSticky = (ref: RefObject<HTMLElement>) => {
  const checkIfScrollStoped = useMemo(
    () =>
      debounce(() => {
        if (ref.current?.style) {
          ref.current.style.top = '0px';
        }
      }, 500),
    [ref],
  );

  let prevScrollY = 0;
  let currScrollY = 0;

  const handleScroll = () => {
    prevScrollY = currScrollY;
    currScrollY = window.scrollY;

    if (
      prevScrollY > currScrollY &&
      prevScrollY - currScrollY > 5 &&
      ref.current?.style
    ) {
      ref.current.style.top = '0px';
    } else if (
      prevScrollY < currScrollY &&
      currScrollY - prevScrollY > 5 &&
      ref.current?.style
    ) {
      ref.current.style.top = `-${ref?.current.clientHeight}px`;
    }

    checkIfScrollStoped();
  };

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    currScrollY = window.scrollY;
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
